import { ClipboardCheckIcon } from 'lucide-react';
import { DropdownMenuItem } from '../../../components/ui/dropdown-menu.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CustomerDTO } from '../../../server/dto/customer-dto.ts';
import { Can } from '../../acl/can.tsx';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import type { CreateNoteFormProps } from './note-form-dialog';
import { NoteFormDialog } from './note-form-dialog';

export type DropdownMenuItemCreateNoteProps = {
    customer?: CustomerDTO;
    onSuccess?: () => void;
    analyticsSource?: CreateNoteFormProps['analyticsSource'];
};

export const DropdownMenuItemCreateNote = ({
    customer,
    onSuccess,
    analyticsSource,
}: DropdownMenuItemCreateNoteProps) => {
    const { t } = useLocale();

    return (
        <Can I="create" a="Note">
            <DropdownMenuItem
                onSelect={() => {
                    DialogStateManager.show(NoteFormDialog, {
                        customer,
                        onSuccess,
                        analyticsSource,
                    } satisfies CreateNoteFormProps);
                }}
            >
                <ClipboardCheckIcon className="h-4 w-4" />
                <span>{t('top_navbar__new_note')}</span>
            </DropdownMenuItem>
        </Can>
    );
};
